/** Helpers de Órdenes de Compra (cabecera / fecha probable de entrega). */

/**
 * OC anulada: el backend pone Nombre = ANULADO (mismo criterio que FC/NC compra).
 * No usar Impreso/Asentado = A solos: en legado esa marca no implica anulación.
 */
export const esOrdenCompraAnulada = (oc: {
  impreso?: string | null;
  nombre?: string | null;
}): boolean => (oc.nombre ?? '').trim().toUpperCase() === 'ANULADO';

/** Normaliza fecha API → YYYY-MM-DD. */
export const toFechaVencimInputValue = (fecha: Date | string | null | undefined): string => {
  if (!fecha) return '';
  if (typeof fecha === 'string') {
    const trimmed = fecha.trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) return trimmed.slice(0, 10);
    const d = new Date(trimmed);
    if (isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  const y = fecha.getFullYear();
  const m = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** YYYY-MM-DD → DD/MM/YYYY (ej. 2026-09-07 → 07/09/2026). */
export const ymdToDdMmYyyy = (ymd: string): string => {
  const m = ymd.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return '';
  return `${m[3]}/${m[2]}/${m[1]}`;
};
